// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".components-slider-standard-item-hlqts{display:block;line-height:0}.components-slider-standard-image-bviwt{transition:all .1s ease-in-out;height:100%;width:100%;border-radius:6px;bottom:0;left:0;overflow:hidden;right:0;top:0}.components-slider-standard-image-bviwt:hover{filter:brightness(.85)}.components-slider-standard-video-bgvhw{height:auto;width:100%;left:0;-o-object-fit:cover;object-fit:cover;position:absolute;top:50%;transform:translateY(-50%)}.components-slider-standard-videoWrapper-rjrch{border-radius:6px;overflow:hidden;position:relative}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"item": "components-slider-standard-item-hlqts",
	"image": "components-slider-standard-image-bviwt",
	"video": "components-slider-standard-video-bgvhw",
	"videoWrapper": "components-slider-standard-videoWrapper-rjrch"
};
module.exports = ___CSS_LOADER_EXPORT___;
